// extracted by mini-css-extract-plugin
export default {"child1":"styles_child1__TmgAN","child2":"styles_child2__JVAih","parent":"styles_parent__OZ4Cq"};